// Interactie en beweging van het Phoenix v2-ontwerp.
(function () {
  // Tabbladen in het schap, ook met pijltjestoetsen
  document.querySelectorAll('[data-p2-schap]').forEach(function (schap) {
    var tabs = Array.prototype.slice.call(schap.querySelectorAll('[role="tab"]'));
    function kies(tab, focus) {
      tabs.forEach(function (t) {
        var aan = t === tab;
        t.classList.toggle('is-aan', aan);
        t.setAttribute('aria-selected', aan);
        t.tabIndex = aan ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !aan;
      });
      if (focus) tab.focus();
      if (window.gsap && !rustig()) {
        var paneel = document.getElementById(tab.getAttribute('aria-controls'));
        gsap.fromTo(paneel.querySelectorAll('.p2-rail__item'), { y: 28, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.55, stagger: 0.05, ease: 'power3.out', clearProps: 'all' });
      }
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { kies(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') kies(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') kies(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
  });

  // Specials: de baan onder de muis, of met focus, klapt open
  document.querySelectorAll('[data-p2-specials]').forEach(function (blok) {
    var banen = blok.querySelectorAll('.p2-baan');
    banen.forEach(function (baan) {
      function open() { banen.forEach(function (b) { b.classList.toggle('is-open', b === baan); }); }
      baan.addEventListener('mouseenter', open);
      baan.addEventListener('focusin', open);
    });
  });

  function rustig() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  // Vaste koopbalk op de telefoon zodra de gewone koopknop uit beeld is
  var plakbalk = document.querySelector('[data-p2-plakbalk]');
  var koopknop = document.querySelector('.product-form__submit');
  if (plakbalk && koopknop && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (items) {
      plakbalk.hidden = items[0].isIntersecting || items[0].boundingClientRect.top > 0;
    }).observe(koopknop);
  }

  if (!window.gsap || !window.ScrollTrigger || rustig()) return;
  gsap.registerPlugin(ScrollTrigger);

  // Opening: de kop komt omhoog en de flessen worden een voor een op het schap gezet
  var hero = document.querySelector('[data-p2-hero]');
  if (hero) {
    var tl = gsap.timeline({ defaults: { ease: 'expo.out' } });
    tl.fromTo(hero.querySelector('.p2-hero__foto img'), { scale: 1.12 }, { scale: 1, duration: 2.2 }, 0)
      .fromTo(hero.querySelectorAll('.p2-regel > span'), { yPercent: 112 }, { yPercent: 0, duration: 1.15, stagger: 0.12 }, 0.1)
      .fromTo(hero.querySelectorAll('.p2-label, .p2-hero__lead, .p2-knoppen'), { y: 22, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.08 }, 0.35)
      .fromTo(hero.querySelectorAll('.p2-fles__beeld'), { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1.05, stagger: 0.09 }, 0.3)
      .fromTo(hero.querySelectorAll('.p2-fles__kaart'), { y: 14, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.7, stagger: 0.07 }, 0.8);

    // Bij scrollen beweegt de stookkamer trager dan de flessen
    gsap.to(hero.querySelector('.p2-hero__foto'), {
      yPercent: 9, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
    gsap.to(hero.querySelector('.p2-hero__tekst'), {
      y: -50, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
  }

  // Koppen van categorie- en informatiepagina's en de flessen daarin
  gsap.utils.toArray('.p2-donkerkop').forEach(function (kop) {
    var foto = kop.querySelector('.p2-donkerkop__foto img');
    if (foto) gsap.fromTo(foto, { scale: 1.1 }, { scale: 1, duration: 2, ease: 'expo.out' });
    gsap.fromTo(kop.querySelectorAll('.p2-regel > span'), { yPercent: 112 }, { yPercent: 0, duration: 1.1, ease: 'expo.out', delay: 0.1 });
    gsap.fromTo(kop.querySelectorAll('.p2-label, .p2-colkop__tekst, .p2-paginakop__tekst'), { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.8, stagger: 0.08, ease: 'power3.out', delay: 0.3 });
    gsap.fromTo(kop.querySelectorAll('.p2-colkop__flessen img'), { y: 80, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1, stagger: 0.12, ease: 'expo.out', delay: 0.2 });
  });

  // Smaakmeters lopen vol als ze in beeld komen
  gsap.utils.toArray('.p2-smaak').forEach(function (blok) {
    gsap.fromTo(blok.querySelectorAll('.is-vol'), { scaleX: 0, transformOrigin: 'left center' }, {
      scaleX: 1, duration: 0.4, stagger: 0.05, ease: 'power2.out', delay: 0.4,
      scrollTrigger: { trigger: blok, start: 'top 92%', once: true }
    });
  });

  // Inhoud van de informatiepagina's
  gsap.utils.toArray('.rich-text__heading, .image-with-text__content, .collapsible-content__heading, .related-products__heading').forEach(function (el) {
    gsap.fromTo(el, { y: 34, autoAlpha: 0 }, {
      y: 0, autoAlpha: 1, duration: 0.95, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 90%', once: true }
    });
  });
  gsap.utils.toArray('.multicolumn-list, .product-grid').forEach(function (lijst) {
    var kaarten = lijst.children;
    gsap.fromTo(kaarten, { y: 46, autoAlpha: 0 }, {
      y: 0, autoAlpha: 1, duration: 0.8, stagger: 0.07, ease: 'power3.out', clearProps: 'transform',
      scrollTrigger: { trigger: lijst, start: 'top 90%', once: true }
    });
  });
  gsap.utils.toArray('.image-with-text__media img').forEach(function (img) {
    gsap.fromTo(img, { scale: 1.1 }, {
      scale: 1, ease: 'none',
      scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  // Koppen en kaarten schuiven eenmalig in beeld
  gsap.utils.toArray('[data-p2-reveal]').forEach(function (el) {
    gsap.fromTo(el, { y: 36, autoAlpha: 0 }, {
      y: 0, autoAlpha: 1, duration: 1, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 90%', once: true }
    });
  });

  // Specials rijzen na elkaar op
  var banen = gsap.utils.toArray('.p2-baan');
  if (banen.length) {
    gsap.fromTo(banen, { y: 70, autoAlpha: 0 }, {
      y: 0, autoAlpha: 1, duration: 0.95, stagger: 0.08, ease: 'power3.out',
      scrollTrigger: { trigger: '.p2-banen', start: 'top 85%', once: true }
    });
  }

  // Blokken van de informatiepagina's komen na elkaar in beeld
  ['.p3-stappen__lijst', '.p3-merken', '.p3-fotorij__rij', '.p3-cijfers__rij'].forEach(function (sel) {
    gsap.utils.toArray(sel).forEach(function (lijst) {
      gsap.fromTo(lijst.children, { y: 54, autoAlpha: 0 }, {
        y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.08, ease: 'power3.out', clearProps: 'transform',
        scrollTrigger: { trigger: lijst, start: 'top 88%', once: true }
      });
    });
  });

  // Tegels bij beleven
  var tegels = gsap.utils.toArray('.p2-tegel');
  if (tegels.length) {
    gsap.fromTo(tegels, { y: 50, autoAlpha: 0 }, {
      y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.08, ease: 'power3.out',
      scrollTrigger: { trigger: '.p2-bezoek__rij', start: 'top 88%', once: true }
    });
  }

  // Grote beelden bewegen licht mee met het scrollen
  [['.p3-hfd__foto img', '.p3-hfd'], ['.p3-citaat__foto img', '.p3-citaat'], ['.p2-beeldp__foto img', '.p2-beeldp'], ['.p2-verhaal__foto img', '.p2-verhaal__foto'], ['.banner__media img', '.banner']].forEach(function (paar) {
    gsap.utils.toArray(paar[0]).forEach(function (img) {
      gsap.fromTo(img, { yPercent: -7 }, {
        yPercent: 7, ease: 'none',
        scrollTrigger: { trigger: img.closest(paar[1]) || img, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  });

  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();
